goog.provide('el8.appchart.mainFeeds.chartTimeline');

goog.require('el8.appservice.notifier');
goog.require('el8.util.datecompare');
goog.require('el8.template.appchart.mainFeeds');

el8.appchart.mainFeeds.chartTimeline = (function() {

    var that = {};

    var MAX_SCORE = 3;
    var NUM_X_BUCKETS = 5;
    var graph = null;

    that.resizeGraph = function() {
        // Need to both resize and re-draw
        if (graph) {
            var data = graph.getData();
            graph.resize();
            graph.setData(data);
            graph.setupGrid(); //only necessary if your new data will change the axes or grid
            graph.draw();
        }
    };

    that.loadGraph = function(index) {
        var now = null, lastDate = null;
        var $visual = $('#chart-feed-visual');
        if (index.length > 0) {
            var data = _computeChartData(index);
            $visual.show();
            if (graph) {
                graph.setData([data]);
                graph.draw();
            } else {
                // Set most recent date to maximum time, and least recent date to zero time
                now = el8.service.tz.now().maxTime();
                lastDate = (el8.service.tz.toTzDateTime(index[index.length-1].feed_date)).zeroTime();
                var inTwoYears = el8.service.tz.today().addYears(-2);
                if (lastDate > inTwoYears) {
                    lastDate = inTwoYears;
                }

                graph = $.plot($visual, [data], {
                    xaxis: {
                        min: lastDate.getTime(),
                        max: now.getTime(),
                        mode: 'time',
                        transform: function(a) { return -1*a; },
                        inverseTransform: function(a) { return -1*a; },
                        ticks: function(axis) {
                            var res = [];
                            var interval = Math.floor((axis.max - axis.min)/NUM_X_BUCKETS);
                            var v = axis.max;
                            do {
                                res.push(v);
                                v -= interval;
                            } while (v >= axis.min);
                            return res;
                        },
                        tickFormatter: function(val, axis) {
                            return (val === now.getTime()) ? 'Today' : el8.service.tz.newTzDate(val).asShortString();
                        },
                        tickLength: 5
                    },
                    yaxis: {
                        max: MAX_SCORE,
                        min: 0,
                        ticks: [[0, '']]
                    },
                    bars: { show: true, barWidth: 1*1000*60*60*24 }, // width is a day
                    //crosshair: { mode: 'x' },
                    selection: { mode: 'x', color: 'rgba(100,50,25,0.4)' },
                    grid: { hoverable: true, clickable: true, borderWidth: 0 }
                });
                var to = null;
                $visual.off('plotclick').on('plotclick', function(e, position, item) {
                    if (el8Globals['TEASE']) { $(document).trigger('timeline-click'); }
                    var newDate = el8.service.tz.newTzDate(position['x']);
                    el8.appservice.notifier.notify('Jumping to activity at ' + newDate.asString());
                    // TODO Problematic because we have a circular reference!
                    el8.appchart.mainFeeds.chart.showPageByDate(newDate);
                    if (to) { clearTimeout(to); }
                    $('#chart-feed-graph-tooltip').remove();
                    return false;
                });
                $visual.off('plothover').on('plothover', function(e, position, item) {
                    var newDate = el8.service.tz.newTzDate(position['x']);
                    if (newDate > now || newDate < lastDate) { return; }
                    if (to) { clearTimeout(to); }
                    $('#chart-feed-graph-tooltip').remove();
                    _showTooltip($visual, position.pageX, position.pageY, 'Jump to ' + newDate.asString());
                    to = setTimeout(function() { $('#chart-feed-graph-tooltip').remove(); }, 1800);
                    return false;
                });
            }
        } else {
            $visual.hide();
        }
    };

    that.showPageOnGraph = function(start_date, end_date) {
        if (graph) {
            graph.setSelection({
                xaxis: { from: end_date.getTime(), to: start_date.getTime() }
            }, true);
        }
    };

    /**
     *  Helper methods
     */
    function _computeChartData(index) {
        var len = index.length;
        var data = [];
        function _getDate(obj) { return el8.service.tz.toTzDateTime(obj.feed_date); }
        function _getScore(obj) { return Math.min(MAX_SCORE, _scoreFn(obj.model_class)); }
        if (len) {
            // State variables for double loop
            var bucketDate = _getDate(index[0]);
            var bucketScore = 0,
                currIndex = 0,
                i = 0;
            while(currIndex < len) {
                bucketDate = _getDate(index[currIndex]);
                bucketScore = 0;
                for (i=currIndex; i<len; i++) {
                    if (el8.util.datecompare.isSameDay(_getDate(index[i]), bucketDate)) {
                        bucketScore += _getScore(index[i]);
                    } else {
                        break;
                    }
                }
                // Want to re-examine this element if items actually added
                if (bucketScore > 0) {
                    currIndex = i;
                // Otherwise, skip over this item; already evaluated
                } else {
                    currIndex++;
                }
                data.push([bucketDate.getTime(), bucketScore]);
            }
        }
        return data;
    }
    function _showTooltip(anchor, x, y, contents) {
        $(el8.template.appchart.mainFeeds.graphTooltip({contents: contents}))
            .css({
                top: y + 5 - anchor.offset().top,
                left: x + 5 - anchor.offset().left
            }).appendTo(anchor).fadeIn(200);
    }
    function _scoreFn(mClass) {
        switch (mClass) {
            case "NonvisitNote": return 3;
            case "VisitNote":  return 5;
            //case "Report":
            //case "LabOrder":
            //case "ImagingOrder":
            //case "SleepOrder":
            //case "CardiacOrder":
            //case "MedOrder": // TODO In future, may have multiple
            //case "DiscontinueMedOrder":
            //case "MessageThread":
            //case "PulmonaryOrder":
            //case "ReferralOrder":
            default: return 1;
        }
    }

    return that;

})();
